import React from 'react';
import ManageLeave from '../../../components/annualLeave/ManageLeave/ManageLeave';

const ManageLeavePage = () => {
    return (
            <ManageLeave />
    );
};

export default ManageLeavePage;